/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Marketing_Pricing_ProvisionalInputs */

const en_marketing_pricing_provisional = /** @type {(inputs: Marketing_Pricing_ProvisionalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pricing is provisional during early access. The full licensing terms come with the purchase.`)
};

const es_marketing_pricing_provisional = /** @type {(inputs: Marketing_Pricing_ProvisionalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Los precios son provisionales durante el acceso anticipado. Los términos completos de la licencia llegan con la compra.`)
};

const fr_marketing_pricing_provisional = /** @type {(inputs: Marketing_Pricing_ProvisionalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Les tarifs sont provisoires pendant l'accès anticipé. Les conditions de licence complètes accompagnent l'achat.`)
};

/**
* | output |
* | --- |
* | "Pricing is provisional during early access. The full licensing terms come with the purchase." |
*
* @param {Marketing_Pricing_ProvisionalInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" }} options
* @returns {LocalizedString}
*/
export const marketing_pricing_provisional = /** @type {((inputs?: Marketing_Pricing_ProvisionalInputs, options?: { locale?: "en" | "es" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Marketing_Pricing_ProvisionalInputs, { locale?: "en" | "es" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_marketing_pricing_provisional(inputs)
	if (locale === "es") return es_marketing_pricing_provisional(inputs)
	return fr_marketing_pricing_provisional(inputs)
});